import {
   ApiObterReferenciaBloqueio,
   ApiObterReferenciaSubPeriodos,
   ApiObterReferencias,
   ApiObterReferenciasPeriodo,
   ApiRegistrarReferenciaBloqueio
} from '@/api'
import { defineStore } from 'pinia'

export const Referencias = defineStore('Referencias', {
   state: () => ({
      referencias: null,
      referenciaBloqueio: null,
      referenciasPeriodo: null,
      referenciaSubPeriodos: null
   }),
   actions: {
      async ActionObterReferencias(filtros) {
         await ApiObterReferencias(filtros).then((resposta) => {
            this.referencias = resposta
         })
      },
      async ActionObterReferenciasPeriodo(filtros) {
         await ApiObterReferenciasPeriodo(filtros).then((resposta) => {
            this.referenciasPeriodo = resposta
         })
      },
      async ActionObterReferenciaBloqueio(id) {
         await ApiObterReferenciaBloqueio(id).then((resposta) => {
            this.referenciaBloqueio = resposta
         })
      },

      async ActionObterReferenciaSubPeriodos(id) {
         await ApiObterReferenciaSubPeriodos(id).then((resposta) => {
            this.referenciaSubPeriodos = resposta
         })
      },

      async ActionRegistrarReferenciaBloqueio(payload) {
         await ApiRegistrarReferenciaBloqueio(payload)
      }
   }
})
